import { TextFieldLayoutItem } from 'models/InputLayoutItem';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import InfoIcon from '@material-ui/icons/Info';
import * as yup from 'yup';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { FORM, LAYOUT_ITEM, PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import 'assets/scss/portabilidad-paso-1.scss';
import { useEffect } from 'react';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';

const storageService = new StorageServiceImpl();

export const PortabilidadPaso1 = () => {
	const firstName = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.FIRST_NAME,
		sessionStorage
	);
	const lastName = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.LAST_NAME,
		sessionStorage
	);

	const fields: TextFieldLayoutItem[] = [
		{
			label: 'Nombre',
			defaultValue: firstName ? firstName : '',
			name: FORM.FIRST_NAME,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: Juan Manuel',
			validation: yup
				.string()
				.required('Campo Requerido')
				.matches(
					/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
					'Ingrese solo letras'
				),
		},
		{
			label: 'Apellidos',
			defaultValue: lastName ? lastName : '',
			name: FORM.LAST_NAME,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: Soto Marín',
			validation: yup
				.string()
				.required('Campo Requerido')
				.matches(
					/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
					'Ingrese solo letras'
				),
		},
	];
	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_1),
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Porta tu crédito automotriz a Crediautos"
				body="Antes de comenzar, nos gustaría conocerte"
			/>

			<CreateFormLayout key={fields.length} fields={fields} />

			<div className="infoCedula">
				<InfoIcon color="secondary" />
				<p className="body primary-color">
					Recuerda tener a mano tu cédula de identidad e información del vehículo a portar.
				</p>
			</div>
		</div>
	);
};
